module.exports = __webpack_public_path__ + "img/mastercard.14bf6bdf.svg";